import useSWR from "swr";

interface UseSubscriptionOfferingsQueryReturn {
  data: any;
  isValidating: boolean;
  mutate: (data?: any, shouldRevalidate?: boolean | undefined) => Promise<any>;
}

export function useSubscriptionOfferingsQuery(
  partnerId: string,
  subscriptionId: string
): UseSubscriptionOfferingsQueryReturn {
  const { data, isValidating, mutate } = useSWR(
    `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/offerings`
  );

  return {
    data: data,
    isValidating,
    mutate,
  };
}
